document.addEventListener('DOMContentLoaded', () => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  const canObserve = !reduceMotion && !designMode && 'IntersectionObserver' in window;

  const revealObserver = canObserve
    ? new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-revealed');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.14, rootMargin: '0px 0px -40px 0px' }
      )
    : null;

  const setupReveal = (root = document) => {
    root.querySelectorAll('[data-reveal]').forEach((element) => {
      if (designMode || !revealObserver) {
        element.classList.add('is-revealed');
        return;
      }

      element.classList.remove('is-revealed');
      revealObserver.observe(element);
    });
  };

  const setupStickyBars = (root = document) => {
    root.querySelectorAll('[data-product-sticky-root]').forEach((rootElement) => {
      if (rootElement.dataset.premiumStickyInit === 'true') return;
      rootElement.dataset.premiumStickyInit = 'true';

      const stickyBar = rootElement.querySelector('[data-product-sticky-bar]');
      const buyButtons = rootElement.querySelector('[data-product-buy-buttons]');
      const stickyPrice = rootElement.querySelector('[data-sticky-price]');
      const livePrice = rootElement.querySelector('[data-sticky-price-source]');

      if (!stickyBar || !buyButtons) return;

      const syncPrice = () => {
        if (!stickyPrice || !livePrice) return;
        stickyPrice.textContent = livePrice.textContent.replace(/\s+/g, ' ').trim();
      };

      syncPrice();

      if ('MutationObserver' in window && livePrice) {
        const priceObserver = new MutationObserver(syncPrice);
        priceObserver.observe(livePrice, { childList: true, subtree: true, characterData: true });
      }

      const stickyObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { threshold: 0.2 }
      );

      stickyObserver.observe(buyButtons);
    });
  };

  const setupCoverageCalculators = (root = document) => {
    root.querySelectorAll('[data-coverage-calculator]').forEach((calculator) => {
      if (calculator.dataset.coverageInit === 'true') return;
      calculator.dataset.coverageInit = 'true';

      const inputs = calculator.querySelectorAll('input');
      const output = calculator.querySelector('[data-coverage-output]');
      const helper = calculator.querySelector('[data-coverage-helper]');

      if (!inputs.length || !output) return;

      const updateCoverage = () => {
        const [areaInput, wasteInput, coverageInput] = inputs;
        const area = Number.parseFloat(areaInput?.value || '0');
        const waste = Number.parseFloat(wasteInput?.value || '0');
        const coverage = Number.parseFloat(coverageInput?.value || '0');
        const unitLabel = calculator.dataset.unitLabel || 'units';
        const resultLabel = calculator.dataset.resultLabel || 'Estimated quantity';

        if (!area || !coverage) {
          output.textContent = `0 ${unitLabel}`;
          if (helper) helper.textContent = `${resultLabel}: voeg geldige waarden toe.`;
          return;
        }

        const totalArea = area * (1 + Math.max(waste, 0) / 100);
        const units = Math.ceil(totalArea / coverage);
        const covered = (units * coverage).toFixed(1).replace(/\.0$/, '');

        output.textContent = `${units} ${unitLabel}`;
        if (helper) helper.textContent = `Geschatte dekking: ${covered}. Controleer altijd de productspecificatie.`;
      };

      inputs.forEach((input) => {
        input.addEventListener('input', updateCoverage);
      });

      updateCoverage();
    });
  };

  const setupPremiumButtons = (root = document) => {
    root.querySelectorAll('.premium-button, .premium-ghost-button, .premium-product-card__button').forEach((button) => {
      if (button.dataset.premiumButtonInit === 'true') return;
      button.dataset.premiumButtonInit = 'true';

      const clearPressed = () => button.classList.remove('is-pressed');

      button.addEventListener('pointerdown', () => {
        button.classList.add('is-pressed');
      });

      button.addEventListener('pointerup', clearPressed);
      button.addEventListener('pointerleave', clearPressed);
      button.addEventListener('blur', clearPressed);
    });
  };

  const initializePremiumTheme = (root = document) => {
    setupReveal(root);
    setupStickyBars(root);
    setupCoverageCalculators(root);
    setupPremiumButtons(root);
  };

  initializePremiumTheme(document);

  document.addEventListener('shopify:section:load', (event) => {
    initializePremiumTheme(event.target);
  });

  document.addEventListener('shopify:section:select', (event) => {
    setupReveal(event.target);
  });
});
